/* eslint-env browser */
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import ReduxPromise from 'redux-promise';

import AppComponent from './containers/AppComponent';
import reducers from './reducers';

const createStoreWithMiddleware = applyMiddleware(ReduxPromise)(createStore);

render(
  <Provider store={createStoreWithMiddleware(reducers)}>
    <AppComponent
      isLocal={typeof window.globalQuery !== 'undefined'
        && typeof window.globalAssociations !== 'undefined'}
      globalQuery={window.globalQuery}
      globalAssociations={window.globalAssociations}
      emptyEvuLoad={window.emptyEvuLoad}
    />
  </Provider>,
  document.getElementById('evu-container'),
);
